<aura-edit-wrapper
  [(isEditing)]="isEditing"
  (saved)="saved.emit($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <aura-internationalization-timezone-form
      [dto]="currentTimezone()"
      [requiredFields]="['email']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-internationalization-timezone-display [currentTimezone]="currentTimezone()" />
  }
</aura-edit-wrapper>
